// /src/services/views.js
import { db, auth } from '../firebase';
import {
  doc,
  runTransaction,
  serverTimestamp,
  increment,
} from 'firebase/firestore';

/**
 * Firestore ルールに一致する形で views を +1 する。
 * 同一トランザクションで /videoViews/{videoId}/users/{uid} も更新する。
 */
export async function bumpVideoView(videoId) {
  const uid = auth.currentUser?.uid;
  if (!uid) throw new Error('not signed in');

  const videoRef = doc(db, 'videos', videoId);
  const userViewRef = doc(db, 'videoViews', videoId, 'users', uid);

  await runTransaction(db, async (tx) => {
    const uvSnap = await tx.get(userViewRef);
    if (!uvSnap.exists()) {
      // 初回
      tx.set(userViewRef, { lastAt: serverTimestamp(), count: 1 });
    } else {
      // 以降（ルール側は 30 秒スロットル）
      tx.update(userViewRef, { lastAt: serverTimestamp(), count: increment(1) });
    }

    const vSnap = await tx.get(videoRef);
    if (!vSnap.exists()) throw new Error('video not found');

    const cur = (vSnap.data().views ?? 0);
    tx.update(videoRef, { views: cur + 1 });
  });
}

/**
 * 同一タブでの二重カウント防止（任意）:
 * 同じ videoId を一定時間内に複数回 bump しないためのローカルキャッシュ。
 */
export function shouldBumpLocal(videoId, ttlMs = 25_000) {
  try {
    const k = `viewed:${videoId}`;
    const prev = Number(localStorage.getItem(k) || 0);
    const now = Date.now();
    if (now - prev < ttlMs) return false;
    localStorage.setItem(k, String(now));
    return true;
  } catch {
    return true;
  }
}
